var map = {
	"./Academy/router.js": "7533",
	"./Actionsboard/router.js": "f10c",
	"./Dev/router.js": "cd9b",
	"./Hosting/router.js": "b207",
	"./Marketplace/router.js": "526e",
	"./Orgchart/router.js": "4033",
	"./Partnership/router.js": "8341",
	"./Presence/router.js": "ae4b",
	"./Process/router.js": "7cb1",
	"./Quest/router.js": "027b",
	"./Saas/router.js": "9768b",
	"./Templates/router.js": "2fcd",
	"./Wiki/router.js": "467fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8b6";